export default "__VITE_ASSET__C8PkPP5q__"